import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="copy" on a link. Copies the url value to the
// clipboard instead of following the link, and says so for a moment. Without
// clipboard access (insecure context, old browser) the link behaves normally.
export default class CopyController extends Controller<HTMLAnchorElement> {
  static targets = ["label"];
  static values = { url: String };

  declare readonly labelTarget: HTMLElement;
  declare readonly urlValue: string;

  copy(event: Event) {
    if (!navigator.clipboard) return;

    event.preventDefault();
    navigator.clipboard.writeText(this.urlValue).then(() => {
      const label = this.labelTarget.textContent;
      this.labelTarget.textContent = "Copied!";
      setTimeout(() => {
        this.labelTarget.textContent = label;
      }, 2000);
    });
  }
}
